import globalParams from "@/CommonDP/utils/globalParams";
import leave from "./modules/leave/index";
import leavePopup from "./modules/leave/leavePopup";
import leavePopupDetail from "./modules/leave/leavePopupDetail";
import leavePopupApproval from "./modules/leave/leavePopupApproval";
import leaveDraftApply from "./modules/leave/leaveDraftApply";
import leaveDraftDetail from "./modules/leave/leaveDraftDetail";
import leaveDraftApproval from "./modules/leave/leaveDraftApproval";
import tz from "./modules/tz/index";
import check from "./modules/check/index.vue";
import publish from "./modules/publish/index.vue";
import commonFlowForm from "./modules/commonFlowForm.vue";

import commonH5 from "@/CommonDP/pages/mainMg/project/approvalFlowH5/modules/common.vue";
import tzH5 from "@/CommonDP/pages/mainMg/project/approvalFlowH5/modules/tz.vue";
import leaveH5 from "@/CommonDP/pages/mainMg/project/approvalFlowH5/modules/leave.vue";

/**
 * 用于注册流程的表单
 * @param {} formKey
 * @param {*} formComponent
 * @param {*} isH5 是否是H5的流程
 */
export function registerFlowForm(formKey, formComponent, isH5) {
  if (!isH5) {
    const comObj = globalParams.get(`flow.form.${formKey}`);
    comObj ? "" : globalParams.set(`flow.form.${formKey}`, formComponent);
  } else {
    const comObjH5 = globalParams.get(`flow.form.${formKey}`);
    comObjH5 ? "" : globalParams.set(`flow.formH5.${formKey}`, formComponent);
  }
}

export function getFormComponent(formKey) {
  return globalParams.get(`flow.form.${formKey}`, null);
}

export function getDetailFormComponent(formKey) {
  return globalParams.get(`flow.form.${formKey}:detail`, null);
}
export function getApprovalFormComponent(formKey) {
  return globalParams.get(`flow.form.${formKey}:approval`, null);
}

/**
 * 注册用户选择对话框。要求组件提供以下接口：
 * 1. 一个 show 方法，用于显示对话框：function show(title, params), 其中 params 可能为空。
 * 2. 一个事件 userSelected. 为了兼容，必需按这个示例来触发事件：this.$emit("userSelected", users, 0, params), 第一个参数，
 *    users 为用户列表，有以下属性，示例：{ userId: "xxxxx", type: 0 }；
 *    其中第二个参数用以标识审批人(0)还是抄送人(1)；
 *    第三个参数 params 是 show 方法传入的参数
 * 使用示例：
 * import myUserSelectDlg from "@/views/xxx/xxx/userSelectDlg"
 * registerUserSelectDlg(myUserSelectDlg)
 * 或
 * registerUserSelectDlg(require("@/views/xxx/xxx/userSelectDlg"))
 */
export function registerUserSelectDlg(component) {
  return globalParams.get(`flow.form.com.userSelectDlg`, component);
}
export function getUserSelectDlg() {
  return globalParams.get(`flow.form.com.userSelectDlg`, null);
}

/**
 * 注册标准的表单组件
 */
export function registerStdFlowForm() {
  registerFlowForm("common", commonFlowForm);
  registerFlowForm("leave", leave);
  registerFlowForm("leavePopup", leavePopup);
  registerFlowForm("leavePopup:detail", leavePopupDetail);
  registerFlowForm("leavePopup:approval", leavePopupApproval);
  registerFlowForm("tz", tz);
  registerFlowForm("check", check);
  registerFlowForm("publish", publish);

  registerFlowForm("leaveWithDraft", leaveDraftApply);
  registerFlowForm("leaveWithDraft:detail", leaveDraftDetail);
  registerFlowForm("leaveWithDraft:approval", leaveDraftApproval);

  registerFlowForm("common", commonH5, true);
  registerFlowForm("tz", tzH5, true);
  registerFlowForm("leave", leaveH5, true);
  registerFlowForm("leaveWithDraft", leaveH5, true);
}
